const DEFAULT_API_BASE_URL = "https://nwtbruael3.execute-api.us-gov-west-1.amazonaws.com/dev";
const DEFAULT_COGNITO_AUTHORITY = "https://cognito-idp.us-gov-west-1.amazonaws.com/us-gov-west-1_aWP8rNv00";
const DEFAULT_COGNITO_CLIENT_ID = "4vec13ulgg4ig88cskmf71tqad";
const DEFAULT_LOCAL_APP_BASE_URL = "https://localhost:3000";
const DEFAULT_PROD_APP_BASE_URL = "https://amx.jhuapl.edu";
const DEFAULT_GEOCODING_SEARCH_URL = "https://nominatim.openstreetmap.org/search";

function envValue(name) {
  const value = process.env[name];
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

function withoutTrailingSlash(value) {
  return value.replace(/\/+$/, "");
}

const isProdBuild = process.env.NODE_ENV === "production";
const deployEnv = envValue("REACT_APP_DEPLOY_ENV") || (isProdBuild ? "prod" : "local");
const defaultAppBaseUrl = isProdBuild ? DEFAULT_PROD_APP_BASE_URL : DEFAULT_LOCAL_APP_BASE_URL;
const appBaseUrl = withoutTrailingSlash(envValue("REACT_APP_APP_BASE_URL") || defaultAppBaseUrl);
const redirectUri = withoutTrailingSlash(envValue("REACT_APP_REDIRECT_URI") || appBaseUrl);
const postLogoutRedirectUri = withoutTrailingSlash(
  envValue("REACT_APP_POST_LOGOUT_REDIRECT_URI") || redirectUri
);
const cognitoAuthority = withoutTrailingSlash(
  envValue("REACT_APP_COGNITO_AUTHORITY") || DEFAULT_COGNITO_AUTHORITY
);

const config = {
  DEPLOY_ENV: deployEnv,
  APP_BASE_URL: appBaseUrl,
  API_BASE_URL: withoutTrailingSlash(envValue("REACT_APP_API_BASE_URL") || DEFAULT_API_BASE_URL),
  GEOCODING_SEARCH_URL: envValue("REACT_APP_GEOCODING_SEARCH_URL") || DEFAULT_GEOCODING_SEARCH_URL,
  cognitoAuthConfig: {
    authority: cognitoAuthority,
    metadataUrl: envValue("REACT_APP_COGNITO_METADATA_URL") || `${cognitoAuthority}/.well-known/openid-configuration`,
    client_id: envValue("REACT_APP_COGNITO_CLIENT_ID") || DEFAULT_COGNITO_CLIENT_ID,
    redirect_uri: redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri,
    response_type: envValue("REACT_APP_COGNITO_RESPONSE_TYPE") || "code",
    scope: envValue("REACT_APP_COGNITO_SCOPE") || "phone openid email"
  },
};

export default config;
